import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  IconButton,
  styled,
  useTheme,
} from "@mui/material";
import { useParams } from "react-router-dom";
import PaginationComponent from "components/ui-components/PaginationComponent";
import { useGetUpcomingRequirementQuery } from "store/slices/apis/manpowerDashboardSlice";

const StyledTableHead = styled(TableCell)({
  fontWeight: 500,
  fontSize: "14px",
  color: "#505258",
  padding: "10px 14px",
  backgroundColor: "#F8F8F8",
  border: "1px solid #D8D8D8",
  textAlign: "center",
  whiteSpace: "nowrap",
  lineHeight: "20px",
  letterSpacing: "0.2px",
});

const StyledTableBody = styled(TableCell)({
  fontWeight: 400,
  fontSize: "14px",
  color: "#5052588A",
  padding: "10px 14px",
  backgroundColor: "#fff",
  border: "1px solid #D8D8D8",
  textAlign: "center",
  whiteSpace: "nowrap",
  lineHeight: "20px",
  letterSpacing: "0.2px",
});

const UpcomgManpowerRequirement = () => {
  const { projectId } = useParams();
  const theme = useTheme();
  const [pageNumber, setPageNumber] = useState(1);
  const rowsPerPage = 5;

  const { data, isLoading, isError, refetch } = useGetUpcomingRequirementQuery({ projectId });

  useEffect(() => {
    refetch();
  }, []);

  const upcomingRequirements = data?.data || [];
  const totalPages = Math.ceil(upcomingRequirements.length / rowsPerPage);

  const paginatedRows = upcomingRequirements.slice(
    (pageNumber - 1) * rowsPerPage,
    pageNumber * rowsPerPage
  );

  return (
    <Box
      sx={{
        width: "100%",
        // height: "100%",
        mt: 0,
        borderRadius: "7px",
        overflow: "hidden",
        backgroundColor: "white",
        border: "1px solid #2525252E",
      }}
    >
      <Box sx={{ p: 2 }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 500,
            fontSize: "18px",
            lineHeight: "100%",
            letterSpacing: "-0.4px",
            color: `${theme?.customSettings?.themeColor}`,
          }}
        >
          Upcoming Manpower Requirement
        </Typography>
        {/* <Typography
          sx={{
            mt: "6px",
            color: "#5052588A",
            mb: "18px",
            fontSize: "14px",
            lineHeight: "100%",
            letterSpacing: "-0.4px",
          }}
        >
          Get a holistic view of how work is being prioritized
        </Typography> */}
      </Box>
      <Paper sx={{ boxShadow: "none" }}>
        <TableContainer>
          <Table sx={{ width: "100%", border: "1px solid #2525252E" }}>
            <TableHead>
              <TableRow>
                {[
                  "Sl No",
                  "Discipline",
                  "Available",
                  "Current Plan",
                  "M+1",
                  "M+2",
                  "M+3",
                  "M+4",
                  "M+5",
                ].map((header) => (
                  <StyledTableHead key={header}>{header}</StyledTableHead>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <StyledTableBody colSpan={9}>Loading...</StyledTableBody>
                </TableRow>
              ) : upcomingRequirements.length === 0 ? (
                <TableRow>
                  <StyledTableBody colSpan={9}>No data available</StyledTableBody>
                </TableRow>
              ) : (
                paginatedRows.map((row, index) => (
                  <TableRow key={row.id || index}>
                    <StyledTableBody>{(pageNumber - 1) * rowsPerPage + index + 1}</StyledTableBody>
                    <StyledTableBody>{row.category}</StyledTableBody>
                    <StyledTableBody>{row.available}</StyledTableBody>
                    <StyledTableBody>{row.currentPlan.toFixed(2)}</StyledTableBody>
                    <StyledTableBody>{row.futurePlan["M+1"].toFixed(2)}</StyledTableBody>
                    <StyledTableBody>{row.futurePlan["M+2"].toFixed(2)}</StyledTableBody>
                    <StyledTableBody>{row.futurePlan["M+3"].toFixed(2)}</StyledTableBody>
                    <StyledTableBody>{row.futurePlan["M+4"].toFixed(2)}</StyledTableBody>
                    <StyledTableBody>{row.futurePlan["M+5"].toFixed(2)}</StyledTableBody>

                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1, pr: 2 }}>
        <PaginationComponent
          pageNumber={pageNumber}
          totalPages={totalPages || 1}
          onPageChange={setPageNumber}
        />
      </Box>
    </Box>
  );
};

export default UpcomgManpowerRequirement;
